import { useEffect, useState } from "react";
import { Button, Loader, Input } from "../../../../../components/ui";
import CoffeeUserRewardsTable from "../../../../../components/parts/tables/coffeeUserRewards";
import { ArrowLeft, Search, FileEarmarkExcel } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { GET_API_URLS } from "../../../../../utils/constant";
import jwtInterceoptor from "../../../../../api/jwtInterceptor";

const CoffeeUserRewards = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState("");
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchData = async (search = "") => {
    setLoading(true);
    setError("");
    try {
      const response = await jwtInterceoptor.get(
        `${GET_API_URLS.COFFEE_USER_REWARDS}${
          search ? `?search=${search}` : ""
        }`
      );
      setTableData(response.data);
    } catch (error) {
      if (error.response?.status === 403) {
        setError("You dont have permission to access this page.");
      } else {
        setError("There was a problem while loading the data.");
      }
      console.log("Error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Debounce search to avoid too many API calls
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery !== "") {
        fetchData(searchQuery);
      } else {
        fetchData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const handleExportToExcel = async () => {
    setExportLoading(true);
    try {
      // const queryParams = new URLSearchParams({
      //   ...(searchQuery && { search: searchQuery }),
      //   export_format: "excel",
      // }).toString();

      const response = await jwtInterceoptor.get(
        `${GET_API_URLS.COFFEE_USER_REWARDS}create_excel/`,
        { responseType: "blob" } // Important for handling binary file data
      );
      
      // Create a download link for the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `coffee-user-rewards-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data. Please try again.");
    }
    setExportLoading(false);
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <h3 style={{ textAlign: "center" }}>{error}</h3>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "10px 0",
            }}
          >
            <Button
              label={
                <>
                  <ArrowLeft /> Back
                </>
              }
              onClick={() => navigate(-1)}
              secondary
              style={{
                padding: "8px 16px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                width: "fit-content",
              }}
            />
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Button
                label={
                  <>
                    <FileEarmarkExcel />{" "}
                    {exportLoading ? "Exporting..." : "Export Excel"}
                  </>
                }
                onClick={handleExportToExcel}
                disabled={exportLoading}
                style={{
                  padding: "8px 16px",
                  cursor: exportLoading ? "default" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "var(--greenColor)",
                  flex: "0 0 150px",
                }}
              />
              <div style={{ width: "300px" }}>
                <Input
                  type="text"
                  placeholder="Search by name or email..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  icon={<Search />}
                />
              </div>
            </div>
          </div>
          <CoffeeUserRewardsTable tableData={tableData} />
        </>
      )}
    </div>
  );
};

export default CoffeeUserRewards;
